import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { TrendingUp } from 'lucide-react';

const ForexPage = () => (
  <ServicePageTemplate
    translationPrefix="forexPage"
    icon={TrendingUp}
    color="from-green-500 to-green-600"
    accentColor="bg-green-50 border border-green-200"
  />
);

export default ForexPage;
